import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, CardTitle } from 'reactstrap';
import {
  iconfaqsRoute,
  helpRoute,
  codeDefinitionsRoute,
  relNotesRoute,
  resourcesRoute,
  gettingStartedRoute,
} from '../../../config/navigation/routes';
import './Support.scss';
import foundryImage from '../../../images/foundry1_min.jpg';

const Support = () => {
  // Support page categories with reorganized items
  const supportItems = [
    {
      title: 'FAQs',
      description: 'Frequently asked questions about the ICON platform',
      route: iconfaqsRoute,
      icon: 'fa-question-circle',
    },
    {
      title: 'Help',
      description: 'General help documentation for using the ICON platform',
      route: helpRoute,
      icon: 'fa-info-circle',
    },
    {
      title: 'Code Definitions',
      description: 'Reference for codes and abbreviations used in the system',
      route: codeDefinitionsRoute,
      icon: 'fa-list-alt',
    },
    {
      title: 'Release Notes',
      description: 'Information about the latest features and updates',
      route: relNotesRoute,
      icon: 'fa-clipboard',
    },
    {
      title: 'Resources',
      description: 'Maximize the value of ICON for research and ultimately submit successful bids to government projects. Certain registrations and certifications must be achieved.',
      route: resourcesRoute,
      icon: 'fa-graduation-cap',
    },
    {
      title: 'Get started doing business with DOD',
      description: 'Doing business with the DOD will require certain registrations and certifications. Click for more details below',
      route: gettingStartedRoute,
      icon: 'fa-certificate',
    },
  ];

  return (
    <Container fluid className="p-0">
      <Helmet>
        <meta charSet="utf-8" />
        <title>NFFS ICON - Support</title>
        <meta name="description" content="Access support resources for the ICON Portal" />
      </Helmet>

      {/* Hero Banner */}
      <div className="support-hero">
        <div className="support-hero-background" style={{ backgroundImage: `url(${foundryImage})` }} />
        <Container>
          <div className="support-hero-content">

            <h1>Support Resources</h1>
            <p className="lead">
              Find help and resources to get the most out of the ICON platform.
            </p>
          </div>
        </Container>
      </div>

      <Container className="nf-support-page">
        <Row className="support-cards-container">
          {supportItems.map((item) => (
            <Col md={6} lg={4} key={item.title} className="mb-4">
              <Card className="h-100 support-card">
                <CardBody>
                  <div className="icon-container">
                    <i className={`fa ${item.icon}`} />
                  </div>
                  <CardTitle tag="h3">{item.title}</CardTitle>
                  <p>{item.description}</p>
                  <Link
                    to={item.route}
                    className="support-button"
                  >
                    View {item.title}
                  </Link>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>

        <div className="support-additional-help mt-5 mb-4">
          <h2>Need More Help?</h2>
          <p>Our team is ready to assist you with any questions or issues you might encounter.</p>

          <div className="contact-info-container">
            <h3>Please direct all inquiries to:</h3>

            <div className="contact-person">
              <p className="contact-name">ICON SUPPORT TEAM</p>
              <p className="contact-org">Non-Ferrous Founders&apos; Society</p>

              <div className="contact-details">
                <p><strong>Phone:</strong> <a href="tel:8472990876">(847) 299-0876</a></p>
                <p><strong>Email:</strong> <a href="mailto:support@iconportal.com?bcc=iconsupport@nffs.atlassian.net&subject=IT%20Support%20Request%20-%20ICON%20Portal&body=Please%20describe%20your%20request%20or%20issue%20below%3A%0A%0A">support@iconportal.com</a></p>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Container>
  );
};

export default Support;



// WEBPACK FOOTER //
// ./src/pages/static/Support/Support.jsx